<template>
  <div id="tabBankWithdrawal" class="page invoice-wrap">
    <section class="flex md12 xs12">
      <div class="flex md12 xs12">
        <label class="select-title">{{ "t.createDate" | translate }}：</label>
        <date-picker v-model="bankWithdrawal.dates" range style="width: 240px;" :format="momentFormat"
          :placeholder="$t('finance.dateRangePlaceholder')"></date-picker>
        <el-button type="success" class="account-statement"
          @click="queryBankWithdrawal">{{ $t('basic.button.search') }}</el-button>
      </div>
      <div class="dataGrid-report">
        <el-table :data="bankWithdrawal.tableData" tooltip-effect="light" class="dataGrid-report-table">
          <el-table-column min-width="240" prop="batch_id" :label="$t('t.id')"></el-table-column>
          <!-- <el-table-column prop="pay_type" label="Method"></el-table-column> -->
          <el-table-column min-width="100" prop="brief" :label="$t('finance.summary')">
            <template slot-scope="scope">
              <p v-for="(value, index) in scope.row.brief.split(';')" :key="index">
                <span v-if="value">{{value}};</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="pay_currency" :label="$t('t.amount')">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_amount">{{ scope.row.pay_currency }} {{ scope.row.pay_amount }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('t.remark')"></el-table-column>
          <el-table-column min-width="150" prop="create_time" :label="$t('tables.listing.recurring_create_time')">
            <template slot-scope="scope">
              {{scope.row.create_time.split('T')[0]}}&nbsp;{{scope.row.create_time.split('T')[1]}}
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('t.status')"></el-table-column>
          <el-table-column min-width="420" prop="operation" :label="$t('finance.operation')">
            <template slot-scope="scope">
              <div class="d-flex align--center justify-center operation-actions">
                <el-button @click="handleView(scope.row)" type="info" size="small" class="handle-view">{{ $t("view") }}</el-button>
                <TableDownloadButton
                  v-if="scope.row.receipt_download"
                  :download-log-id="scope.row.batch_id"
                  api-url="api/dashboard/merchant/assets/batch-withdraw-virtual-account/temp-receipt-url"
                  :label="$t('finance.receiptDownload')"
                />
                <TableDownloadButton
                  v-if="scope.row.report_download"
                  :download-log-id="scope.row.batch_id"
                  api-url="api/dashboard/merchant/assets/batch-withdraw-virtual-account/temp-report-url"
                  :label="$t('finance.reportDownload')"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="bankWithdrawal.total > bankWithdrawal.pageSize">
          <pagination :total="bankWithdrawal.total" layout="total, sizes, prev, pager, next, jumper"
            background :page-size="bankWithdrawal.pageSize" :page.sync="bankWithdrawal.pageNum"
            :limit.sync="bankWithdrawal.pageSize" :page-sizes="[10, 50, 100]"
            @pagination="queryBankWithdrawal" />
        </div>
      </div>
    </section>

    <vuestic-modal show.sync="true"
                   ref="showDetail"
                   :okText="'modal.confirm2' | translate"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   class="show-detail"
                   :large="true">
      <div slot="title">{{ $t("settlement_details.title") }}</div>
      <!-- <div slot="title">{{'modal.refundReason' | translate}}</div> -->
      <div>
        <div class="va-row">
          <div class="flex xs12 md12" v-if="bankDetail.status === 'REJECTED'"> <span class="text-danger">Refusal Reason：</span><b class="text-danger">{{ bankDetail.reason }}</b> </div>
          <div class="flex xs12 md6"> <span>ID：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.batch_id }}</b> </div>
          <div class="flex xs12 md6"> <span>Status：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.status }}</b> </div>
          <div class="flex xs12 md6"> <span>Summary：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.brief }}</b> </div>
          <div class="flex xs12 md6"> <span>Create Time：</span><b style="word-break: break-all;font-weight: bold;" v-if="bankDetail.create_time">{{bankDetail.create_time.split('T')[0]}}&nbsp;{{bankDetail.create_time.split('T')[1]}}</b> </div>
          <div class="flex xs12 md6"> <span>Account：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.account }}</b> </div>
        </div>
        <h3 class="mt-1 mb-1">{{ $t("finance.withdrawalDetail") }}</h3>
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="(item, index) in withdrawalDetailHeader" :key="index">
                  {{ item.label | translate }}
                </th>
              </tr>
            </thead>
            <tbody v-if="bankDetail.withdraws && bankDetail.withdraws.length > 0">
              <tr v-for="(item, index) in bankDetail.withdraws" :key="index">
                <td> {{ item.request_currency || '-' }} </td>
                <td>{{ item.request_amount || '-' }}</td>
                <td>{{ item.ex_rate || '-' }}</td>
                <td v-if="item.payout_amount">{{ item.payout_currency }} {{ item.payout_amount }}</td>
                <td v-else>-</td>
              </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="13" v-text="noData"></td>
            </tr>
            </tbody>
          </table>
        </div>

        <h3 class="mt-1 mb-1">{{ $t("finance.summary") }}</h3>
        <div class="va-row">
          <div class="flex xs12 md5"> <span>{{ $t("finance.totalExchangeAmount") }}：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.payout_currency }} {{ bankDetail.payout_amount }}</b> </div>
          <div class="flex xs12 md3"> <span>{{ $t("finance.fee") }}：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.settlement_fee_currency }} {{ bankDetail.settlement_fee }}</b> </div>
          <div class="flex xs12 md4"> <span>{{ $t("finance.finalPayAmount") }}：</span><b style="word-break: break-all;font-weight: bold;">{{ bankDetail.pay_currency }} {{ bankDetail.pay_amount }}</b> </div>
        </div>

      </div>
      <div slot="footer">
        <button type="button" class="btn btn-secondary handle-close" @click="handleClose">
          {{ $t("modal.close") }}
        </button>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import { request, exportFileRes, formatDate2Day, getStartDateOf1Month } from "@/utils/utils";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Pagination from "../../Pagination/index";
import TableDownloadButton from "@/package/TableDownloadButton.vue";
var moment = require("moment-timezone");

export default {
  name: 'BankWithdrawal',
  data() {
    return {
			bankWithdrawal: {
				total: 0,
				pageNum: 1,
				pageSize: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
      momentFormat: "",
      bankDetail: { bank_account: {} },
      withdrawalDetailHeader: [
        { label: "t.currency", key: "request_currency", id: 1 },
        { label: "finance.withdrawAmount", key: "request_amount", id: 2 },
        { label: "finance.exchangeRate", key: "ex_rate", id: 3 },
        { label: "finance.exchangeAmount", key: "payout_amount", id: 4 },
      ],
      noData: this.$t("t.noDataNoOrder"),
    }
  },
  methods: {
    stringifyDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },
		queryBankWithdrawal() {
			this.$set(this.bankWithdrawal, "tableData", []);
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				page_num: this.bankWithdrawal.pageNum,
				page_size: this.bankWithdrawal.pageSize,
				start_date: this.stringifyDate(this.bankWithdrawal.dates[0]) + ' 00:00:00',
				end_date: this.stringifyDate(this.bankWithdrawal.dates[1]) + ' 23:59:59',
			};
      this.loadingFullScreen('batchWithdrawListLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/batch-withdraw-virtual-account/list",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
          this.batchWithdrawListLoading.close()
					let data = res.data;
					if (data.code !== '10000') {
						return;
					}
					this.$set(this.bankWithdrawal, "total", data.data.total);

					if (data.data.list.length > 0) {
						let lists_tr = data.data.list.map(v => {
							if (v.desc) {
								v.desc = JSON.parse(v.desc).remark
							}
							return v;
						})
						this.$set(this.bankWithdrawal, "tableData", lists_tr);
					} else {
						return;
					}
				})
				.catch(err => { this.batchWithdrawListLoading.close() });
		},
    handleView(item) {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				batch_id: item.batch_id
			};
      this.loadingFullScreen('viewLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/batch-withdraw-virtual-account/detail",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
          this.viewLoading.close()
					let data = res.data;
					if (data.code !== '10000') {
						return;
					}
          this.bankDetail = data.data
          this.$refs.showDetail.open()
				})
				.catch(err => { this.viewLoading.close() });
    },
    handleClose() {
      this.bankDetail = { bank_account: {} }
      this.$refs.showDetail.close()
    },
    loadingFullScreen(controller, txt, className) {
			this[controller] = this.$loading({
				lock: true,
				text: txt,
				spinner: className,
				background: 'rgba(0, 0, 0, 0.7)',
			})
		}
  },
  components: {
    DatePicker, Pagination, TableDownloadButton
  },
  computed: {
    accountInfo() {
      if (this.bankDetail.bank_account) { return this.bankDetail.bank_account }
      return {}
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./financialManagement.scss";
*,
*:after,
*:before {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

.handle-view {
  padding: 9px 15px;
}
.operation-actions {
  flex-wrap: nowrap;

  /deep/ .el-button {
    flex-shrink: 0;
    white-space: nowrap;
  }
}
.handle-close {
  padding: 0.5rem 2rem;
}
/deep/ .show-detail {
  .modal-lg {
    max-width: 950px;
  }
}
</style>
